import React from 'react';
import reactDom from '../../../../common/react/dom/index';
import EditPassword from '../../../../components/frontend/account/editPassword';

export default function init() {
	reactDom(<EditPassword />, 'js-react-editPassword');
}
